/* KOJO · password page behaviour (sections/kojo-password.liquid).
   <kj-countdown>  wall-clock date in an IANA zone → UTC with Intl (DST-aware, no libraries), ticks every second,
                   pauses while the tab is hidden, shows the end text at zero, hides itself when the date is invalid.
   <kj-pw-media>   background video: loads only the source for the current breakpoint (lightest mp4 that still covers
                   the screen), fades in once playing, pause/play button (WCAG 2.2.2), no autoplay with reduced motion
                   or Save-Data, pauses while the tab is hidden.
   Forms           focus the field / message flagged after a POST, loading state + no double submit.
   Independent from kojo-core.js (works even if it is missing). Safe to load several times. */
(function () {
  'use strict';
  if (window.__kjPassword) return;
  window.__kjPassword = true;

  var doc = document;
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- time zones: wall-clock time in `tz` → UTC epoch ms ---------- */
  var fmtCache = {};
  function partsAt(tz, ms) {
    var f = fmtCache[tz];
    if (!f) {
      f = fmtCache[tz] = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
      });
    }
    var out = {};
    f.formatToParts(new Date(ms)).forEach(function (p) { if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10); });
    return out;
  }
  // offset of `tz` from UTC (ms) at the instant `ms`
  function offsetAt(tz, ms) {
    var p = partsAt(tz, ms);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - Math.floor(ms / 1000) * 1000;
  }
  // DST-aware: an ambiguous autumn time resolves to its second occurrence, a time skipped in spring to one hour later
  function zonedToUtc(y, mo, d, h, mi, tz) {
    var wall = Date.UTC(y, mo - 1, d, h, mi, 0);
    if (!tz || tz === 'UTC' || tz === 'Etc/UTC') return wall;
    try {
      var off1 = offsetAt(tz, wall);
      var guess = wall - off1;
      var off2 = offsetAt(tz, guess);
      if (off2 === off1) return guess;
      var guess2 = wall - off2;
      return offsetAt(tz, guess2) === off2 ? guess2 : Math.max(guess, guess2);
    } catch (e) {
      // no Intl time-zone support: fall back to the visitor's local clock
      return new Date(y, mo - 1, d, h, mi, 0).getTime();
    }
  }
  var TARGET_RE = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2})(?:[:.](\d{1,2}))?)?\s*$/;
  function parseTarget(str, tz) {
    var m = TARGET_RE.exec(str || '');
    if (!m) return NaN;
    var y = +m[1], mo = +m[2], d = +m[3], h = m[4] ? +m[4] : 0, mi = m[5] ? +m[5] : 0;
    if (mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59) return NaN;
    // reject impossible days (e.g. 2026-02-30)
    var check = new Date(Date.UTC(y, mo - 1, d));
    if (check.getUTCMonth() !== mo - 1) return NaN;
    return zonedToUtc(y, mo, d, h, mi, tz);
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  // exposed for tests / other kojo modules
  window.KJPassword = { zonedToUtc: zonedToUtc, parseTarget: parseTarget };

  /* ---------- <kj-countdown data-target="2026-11-01 20:00" data-tz="Europe/Madrid"> ---------- */
  if (window.customElements && !customElements.get('kj-countdown')) {
    customElements.define('kj-countdown', class extends HTMLElement {
      connectedCallback() {
        this.target = parseTarget(this.getAttribute('data-target'), this.getAttribute('data-tz') || 'Europe/Madrid');
        if (isNaN(this.target)) { this.hidden = true; return; }
        this.hidden = false;
        var self = this;
        this.nums = {};
        each(this.querySelectorAll('[data-kj-cd]'), function (el) { self.nums[el.getAttribute('data-kj-cd')] = el; });
        this.endEl = this.querySelector('[data-kj-cd-end]');
        if (!this._onVis) this._onVis = function () { self.tick(); };
        doc.addEventListener('visibilitychange', this._onVis);
        this.tick();
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        clearTimeout(this._t);
        if (this._onVis) doc.removeEventListener('visibilitychange', this._onVis);
      }
      put(key, val) {
        var el = this.nums[key];
        if (el && el.textContent !== val) el.textContent = val;
      }
      tick() {
        clearTimeout(this._t);
        var left = this.target - Date.now();
        if (left <= 0) { this.finish(); return; }
        var s = Math.ceil(left / 1000);
        this.put('d', pad(Math.floor(s / 86400)));
        this.put('h', pad(Math.floor((s % 86400) / 3600)));
        this.put('m', pad(Math.floor((s % 3600) / 60)));
        this.put('s', pad(s % 60));
        if (doc.hidden) return; // resumes on visibilitychange
        var self = this;
        this._t = setTimeout(function () { self.tick(); }, (left % 1000 || 1000) + 15);
      }
      finish() {
        if (this.classList.contains('is-done')) return;
        this.classList.add('is-done');
        ['d', 'h', 'm', 's'].forEach(function (k) { this.put(k, '00'); }, this);
        var text = this.endEl ? this.endEl.getAttribute('data-text') || '' : '';
        if (text) this.endEl.textContent = text; else this.hidden = true;
        if (this._onVis) doc.removeEventListener('visibilitychange', this._onVis);
      }
    });
  }

  /* ---------- <kj-pw-media>: background video ---------- */
  function parseSources(str) {
    return String(str || '').split(',').map(function (x) {
      var p = x.split('|');
      return p.length >= 3 ? { w: +p[0], h: +p[1], url: p.slice(2).join('|') } : null;
    }).filter(function (x) { return x && x.w > 0 && x.url; }).sort(function (a, b) { return a.w - b.w; });
  }
  // lightest source that still covers the viewport (object-fit: cover); phones ignore DPR to save data
  function pickSource(list, ratio) {
    var vw = window.innerWidth || doc.documentElement.clientWidth || 1280;
    var vh = window.innerHeight || doc.documentElement.clientHeight || 800;
    var cover = Math.max(vw, vh * (ratio || 16 / 9));
    var dpr = vw < 750 ? 1 : Math.min(window.devicePixelRatio || 1, 1.5);
    var need = Math.min(cover * dpr, 1920) * 0.85;
    for (var i = 0; i < list.length; i++) { if (list[i].w >= need) return list[i]; }
    return list[list.length - 1];
  }

  if (window.customElements && !customElements.get('kj-pw-media')) {
    customElements.define('kj-pw-media', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.videos = Array.prototype.slice.call(this.querySelectorAll('video[data-kj-pw-video]'));
        if (!this.videos.length) return;
        var root = this.closest('.kj-pw') || doc;
        this.btn = root.querySelector('[data-kj-pw-toggle]');
        // autoplay unless the visitor asked for less motion / less data — the button can still start it
        this.paused = reduced() || saveData();
        this._sync = function () { self.sync(); };
        this._onClick = function () { self.paused = !self.paused; self.sync(); };
        this.videos.forEach(function (v) {
          v.muted = true;
          v.setAttribute('muted', '');
          if (v._kjPw) return;
          v._kjPw = true;
          v.addEventListener('playing', function () { v.classList.add('is-playing'); });
          // never let anything else (browser resume, extensions) restart a video the visitor paused
          v.addEventListener('play', function () { if (self.paused || v !== self.active()) v.pause(); });
        });
        this.mq = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
        if (this.mq) { if (this.mq.addEventListener) this.mq.addEventListener('change', this._sync); else if (this.mq.addListener) this.mq.addListener(this._sync); }
        doc.addEventListener('visibilitychange', this._sync);
        if (this.btn) { this.btn.hidden = false; this.btn.addEventListener('click', this._onClick); }
        this.sync();
      }
      disconnectedCallback() {
        if (!this._sync) return;
        if (this.mq) { if (this.mq.removeEventListener) this.mq.removeEventListener('change', this._sync); else if (this.mq.removeListener) this.mq.removeListener(this._sync); }
        doc.removeEventListener('visibilitychange', this._sync);
        if (this.btn) this.btn.removeEventListener('click', this._onClick);
        (this.videos || []).forEach(function (v) { try { v.pause(); } catch (e) {} });
      }
      active() {
        for (var i = 0; i < this.videos.length; i++) {
          if (window.getComputedStyle(this.videos[i]).display !== 'none') return this.videos[i];
        }
        return null;
      }
      updateButton() {
        if (!this.btn) return;
        this.btn.classList.toggle('is-paused', this.paused);
        var label = this.paused ? this.btn.getAttribute('data-label-play') : this.btn.getAttribute('data-label-pause');
        if (label) this.btn.setAttribute('aria-label', label);
      }
      sync() {
        var self = this;
        var cur = this.active();
        this.videos.forEach(function (v) { if (v !== cur && !v.paused) v.pause(); });
        this.updateButton();
        if (!cur) return;
        if (this.paused || doc.hidden) { if (!cur.paused) cur.pause(); return; }
        if (!cur.getAttribute('src')) {
          var list = parseSources(cur.getAttribute('data-srcs'));
          if (!list.length) return;
          cur.src = pickSource(list, parseFloat(cur.getAttribute('data-ar')) || 16 / 9).url;
        }
        var p = cur.play();
        if (p && p.catch) {
          p.catch(function (err) {
            // autoplay refused (e.g. iOS Low Power Mode): show the play button instead of a dead video
            if (err && err.name === 'NotAllowedError') { self.paused = true; self.updateButton(); }
          });
        }
      }
    });
  }

  /* ---------- forms ---------- */
  function initForms(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : doc;
    each(scope.querySelectorAll('.kj-pw form'), function (form) {
      if (form._kjPw) return;
      form._kjPw = true;
      form.addEventListener('submit', function (e) {
        if (form._kjBusy) { e.preventDefault(); return; }
        form._kjBusy = true;
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      });
    });
    focusFlagged(scope);
  }
  // after a POST: wrong password → focus the field; newsletter → focus the result / the email field, card in view
  function focusFlagged(scope) {
    var target = (scope || doc).querySelector('.kj-pw [data-kj-pw-focus]');
    if (!target || !doc.contains(target)) return;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    var card = target.closest('.kj-pw__card');
    if (card) {
      var r = card.getBoundingClientRect();
      var vh = window.innerHeight || doc.documentElement.clientHeight;
      if (r.top < 0 || r.bottom > vh) card.scrollIntoView({ block: r.height > vh ? 'start' : 'center', behavior: 'auto' });
    }
  }
  // the newsletter redirect lands on …#kj-pw-news: the browser's fragment navigation runs after DOMContentLoaded and
  // drops focus back to <body> — focus again once it is done (only if nothing else has taken focus meanwhile)
  window.addEventListener('load', function () {
    setTimeout(function () {
      var a = doc.activeElement;
      if (!a || a === doc.body || a === doc.documentElement) focusFlagged(doc);
    }, 60);
  });
  // back/forward cache: undo the loading state
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    each(doc.querySelectorAll('.kj-pw form'), function (form) {
      form._kjBusy = false;
      each(form.querySelectorAll('.is-loading'), function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initForms(doc); });
  else initForms(doc);
  doc.addEventListener('shopify:section:load', function (e) { initForms(e.target); });
})();
